import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, SortableList } from 'modules/common/components';
import StageItem from './StageItem';
import { StageList } from 'modules/common/styles/stage';
var uuid = require('uuid');
const propTypes = {
  onChangeStages: PropTypes.func.isRequired,
  stages: PropTypes.array.isRequired,
  placeholder: PropTypes.string.isRequired,
  keyname: PropTypes.string,
  valuename: PropTypes.string,
  buttonName: PropTypes.string,
  showglobalTrue: PropTypes.bool,
  showSpeechRate: PropTypes.bool,
  showcombineDigits: PropTypes.bool
};

class Stages extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.onStageInputKeyPress = this.onStageInputKeyPress.bind(this);
  }

  componentDidMount() {
    // if (this.props.stages.length === 0) {
    //   this.add();
    // }
  }

  onChange(_id, tType, e) {
    console.log(e);
    // console.log(e.target, _id);
    // if(this.props.showglobalTrue){
    const { name, value, checked } = e.target;
    const { stages, onChangeStages } = this.props;
    const stage = stages.find(s => s._id === _id);
    if (this.props.showglobalTrue && tType === 'global') {
      stage['global'] = checked;
    }
    if (this.props.showcombineDigits && tType === 'combineDigits') {
      stage['combineDigits'] = checked;
    }
    if (this.props.showSpeechRate && tType === 'speechRate') {
      stage['speechRate'] = value;
    }
    stage[name] = value;

    onChangeStages(stages);
    // }
    // const { name, value } = e.target;
    // const { stages, onChangeStages } = this.props;

    // const stage = stages.find(s => s._id === _id);
    // stage[name] = value;

    // onChangeStages(stages);
  }

  add() {
    const { stages, onChangeStages, keyname, valuename } = this.props;
    console.log(this.props);
    let tmp = {
      _id: uuid.v4()
    };
    tmp[keyname] = '';
    tmp[valuename] = '';
    if (this.props.showglobalTrue) {
      tmp['global'] = false;
    }
    if (this.props.showcombineDigits) {
      tmp['combineDigits'] = false;
    }
    if (this.props.showSpeechRate) {
      tmp['speechRate'] = 1.0;
    }
    stages.push(tmp);

    console.log(stages);
    onChangeStages(stages);
  }

  remove(_id) {
    console.log(_id);
    const { stages, onChangeStages } = this.props;
    console.log(stages, onChangeStages);
    const remainedStages = stages.filter(stage => stage._id !== _id);
    console.log(remainedStages);
    onChangeStages(remainedStages);
  }

  onStageInputKeyPress(e) {
    if (e.key === 'Enter') {
      this.add();
      e.preventDefault();
    }
  }

  render() {
    const child = stage => (
      <StageItem
        stage={stage}
        placeholder={this.props.placeholder}
        onChange={this.onChange}
        keyname={this.props.keyname}
        valuename={this.props.valuename}
        showglobalTrue={this.props.showglobalTrue}
        showSpeechRate={this.props.showSpeechRate}
        showcombineDigits={this.props.showcombineDigits}
        remove={this.remove}
        onKeyPress={this.onStageInputKeyPress}
      />
    );
    return (
      <StageList>
        <SortableList
          fields={this.props.stages || []}
          child={child}
          onChangeFields={this.props.onChangeStages}
          isModal={true}
        />
        <Button onClick={this.add} btnStyle="success" size="small" icon="add">
          {this.props.buttonName}
        </Button>
      </StageList>
    );
  }
}

Stages.propTypes = propTypes;

export default Stages;



// WEBPACK FOOTER //
// ./src/modules/common/components/Stages.js